import { Color } from '@/utils'

export const buttonColors = {
    primary: {
        default: Color.primary,
        hover: Color.primaryHover,
        active: Color.primaryActive,
        disabled: Color.primaryDisabled,
    },

    yellow: {
        default: Color.yellow,
        hover: Color.yellowHover,
        active: Color.yellowActive,
        disabled: Color.yellowDisabled,
    },

    danger: {
        default: Color.danger,
        hover: Color.dangerHover,
        active: Color.dangerActive,
        disabled: Color.dangerDisabled,
    },

    red: {
        default: Color.red,
        hover: Color.redHover,
        active: Color.redActive,
        disabled: Color.redDisabled,
    },

    greenSmoke: {
        default: Color.greenSmoke,
        hover: Color.greenSmokeHover,
        active: Color.greenSmokeActive,
        disabled: Color.greenSmokeDisabled,

        text: Color.primary,
        textHover: Color.primaryHover,
        textActive: Color.primaryActive,
        textDisabled: Color.primaryDisabled,
        textInverted: Color.primary,
    },

    ghost: {
        default: Color.inherit,
        hover: Color.inherit,
        active: Color.inherit,
        disabled: Color.inherit,

        text: Color.primary,
        textHover: Color.primaryHover,
        textActive: Color.primaryActive,
        textDisabled: Color.primaryDisabled,
        textInverted: Color.primary,
    },
}